import { Collapse } from 'bootstrap';

import * as utils from '../utils'
import * as io from '../components/io-users'
import { getCookie, setCookie } from '../components/cookies'

const anonymousImg = '/assets/images/anonymous.webp'

/*import interfaces*/
import { Aeroval } from '../types/global';
declare var aeroval: Aeroval;


export function initMyAeroval() {
  initUser();
  //getPyaeroptions();
  getForms();

  if (aeroval.settings.theme) {
    document.querySelectorAll('.g-recaptcha').forEach(el => {
      el.setAttribute('data-theme', aeroval.settings.theme);
    });
  }
  const recaptchaWarningElement = document.getElementById('recaptcha-warning')
  if (recaptchaWarningElement && window.location.origin !== 'https://aerosol-alerts.atmosphere.copernicus.eu' && !window.location.origin.startsWith('http://localhost')) {
    recaptchaWarningElement.innerHTML = '<div class="alert alert-warning" role="alert">Signing up is only possible from the <a href="https://aerosol-alerts.atmosphere.copernicus.eu/subscription/">official CAMS website</a></div>';
  }

  // add events for static forms
  const fileInput = document.getElementById('uploadFile') as HTMLInputElement;
  const uploadButton = document.getElementById('upload-but') as HTMLButtonElement;
  const makeCfgButton = document.getElementById('make-cfg-but') as HTMLButtonElement;

  fileInput.addEventListener('change', () => {
    uploadButton.disabled = !fileInput.files || fileInput.files.length === 0;
  });

  // enable submit button when both upload and make config are done
  const submitButton = document.getElementById('submit-but') as HTMLButtonElement;
  uploadButton.addEventListener('click', () => {
    if (uploadButton.disabled || makeCfgButton.disabled) return
    submitButton.disabled = false;
  })
  makeCfgButton.addEventListener('click', () => {
    if (uploadButton.disabled || makeCfgButton.disabled) return
    submitButton.disabled = false;
  })

}



/*function newEvent() {
  // Clean the map and coordinates
  (window as any).drawnItems?.clearLayers();

  const nameInput = document.getElementById('name') as HTMLInputElement;
  const coordsInput = document.getElementById('drawMapCoords') as HTMLInputElement;
  const subscribeButton = document.getElementById('subscribe') as HTMLButtonElement;

  if (nameInput) nameInput.value = '';
  if (coordsInput) {
    coordsInput.value = '';
    coordsInput.classList.replace('is-valid', 'is-invalid');
  }
  if (subscribeButton) subscribeButton.disabled = true;
}*/

function getForm(formId: string) {
  const formElement = (document.forms as any)[formId];
  if (!formElement) {
    console.error(`Form not found: ${formId}`);
    return;
  }

  // Define all form key sets in one place
  const formKeysMap: Record<string, string[]> = {
    'sign-in-form': ['mail', 'password'],
    'sign-up-form': ['firstname', 'lastname', 'mail', 'password'],
    'config-file-form': ['experiment', 'project', 'param', 'model', 'level'],
    'profile-form': ['firstname', 'lastname', 'mail', 'date', 'title', 'name', 'param', 'model', 'level'],
    'resetpassword-form': ['mail'],
  };

  const keys = formKeysMap[formId];
  if (!keys) {
    console.error(`Unknown form ID: ${formId}`);
    return;
  }

  // Build the form object
  const form: Record<string, string> = {};
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i]
    const input = formElement[i] as HTMLInputElement | undefined;
    form[key] = input?.value ?? '';
  }
  // Validate
  const error = checkForm(formId, form);
  if (error === 0) {
    return form;
  }
}

function checkForm(formId: string, form: Record<string, string>): number {
  let error = 0;

  const formKeysMap: Record<string, string[]> = {
    'sign-up-form': ['firstname', 'lastname', 'mail', 'password'],
    'subscription-form': ['name'],
    'config-file-form': ['experiment', 'project', 'param', 'model', 'level'],
  };

  const keys = formKeysMap[formId];
  if (!keys) return 0; // no validation needed for other forms

  // Identify the status element based on formId
  const statusElementId = formId.replace('-form', '-status');
  const statusElement = document.getElementById(statusElementId);

  for (const key of keys) {
    if (!form[key]?.trim()) {
      error++;
    }
  }

  // Show an error message if any field is empty
  if (error > 0 && statusElement) {
    statusElement.textContent = 'Please complete all the fields';
    statusElement.style.color = 'red';
    statusElement.style.display = 'block';

    // Smoothly fade out the message after 3 seconds
    setTimeout(() => {
      statusElement.style.transition = 'opacity 0.5s';
      statusElement.style.opacity = '0';
      setTimeout(() => (statusElement.style.display = 'none'), 500);
    }, 3000);
  }

  return error;
}


async function initUser() {
  const access_token = getCookie('access_token');
  const userData = await io.getUser(access_token)
  fillOutForms('user', userData);
  if (userData.id != -1) {
    fillInUserForms(userData);
  } else {
    showSignIn();
  }
}

export async function signIn() {
  const formData = getForm('sign-in-form') as LoginData;
  const passwordStatusElement = document.getElementById('password-status')
  try {
    const loginResult = await io.loginUser(formData.mail, formData.password)
    if (loginResult.access_token) setCookie('access_token', loginResult.access_token, 7)
    passwordStatusElement!.innerHTML = 'login successful'
    passwordStatusElement!.className = 'text-success'
    setTimeout(async function () {
      initUser();
    }, 1000)
  } catch {
    passwordStatusElement!.innerHTML = 'wrong email/password'
    passwordStatusElement!.className = 'text-danger'
  }
}

export async function deleteSub() {
  const userSubs = (document.forms as any)['profile-form']['current-sub'] as HTMLSelectElement;
  const selectedSubIndex = userSubs.selectedIndex;
  const selectedSubId = Number(userSubs[selectedSubIndex].getAttribute('sub-id'));
  const accessToken = getCookie('access_token');
  if (!accessToken) return;

  const statusEl = document.getElementById('subscription-status');
  if (!statusEl) return;

  try {
    await io.removeSub(accessToken, selectedSubId);

    statusEl.textContent = 'Alert deleted';
    statusEl.classList.remove('text-danger');
    statusEl.classList.add('text-warning');
    statusEl.classList.remove('fade-out');
    statusEl.style.display = 'block';

    setTimeout(() => statusEl.classList.add('fade-out'), 3000);

    setTimeout(() => initUser(), 1000);
  } catch (err) {
    console.error(err);

    statusEl.textContent = 'Delete failed';
    statusEl.classList.remove('text-warning');
    statusEl.classList.add('text-danger');
    statusEl.classList.remove('fade-out');
    statusEl.style.display = 'block';

    setTimeout(() => statusEl.classList.add('fade-out'), 5000);
  }
}

export async function updateSub() {
  // Get form data
  const data = getForm('profile-form');
  if (!data) return;

  const userSubs = (document.forms as any)['profile-form']['current-sub'] as HTMLSelectElement
  const selectedSubIndex = userSubs.selectedIndex;
  const selectedSubId = Number(userSubs[selectedSubIndex].getAttribute('sub-id'));
  const accessToken = getCookie('access_token');
  if (!accessToken) return;

  try {
    await io.updateSub(
      accessToken,
      selectedSubId,
      data["param"],
      data["model"],
      Number(data["level"]),
      data["name"]
    );

    const statusEl = document.getElementById('subscription-status');
    if (!statusEl) return;

    statusEl.textContent = 'Alert updated';
    statusEl.classList.remove('text-danger');
    statusEl.classList.add('text-success');
    statusEl.classList.remove('fade-out'); // reset fade
    statusEl.style.display = 'block';

    // Trigger fade-out after 3 seconds
    setTimeout(() => statusEl.classList.add('fade-out'), 3000);

    // Reload user profile
    setTimeout(() => initUser(), 1000);
  } catch (err) {
    console.error(err);
    const statusEl = document.getElementById('subscription-status');
    if (!statusEl) return;

    statusEl.textContent = 'Update failed';
    statusEl.classList.remove('text-success');
    statusEl.classList.add('text-danger');
    statusEl.classList.remove('fade-out'); // reset fade
    statusEl.style.display = 'block';

    setTimeout(() => statusEl.classList.add('fade-out'), 5000);
  }
}

async function fillInUserForms(data: UserData) {

  // --- Collapse show/hide ---
  const signIn = document.getElementById("sign-in");
  const profile = document.getElementById("profile");
  const newEval = document.getElementById("new-eval");

  if (signIn) new Collapse(signIn, { toggle: false }).hide();
  if (profile) new Collapse(profile, { toggle: false }).show();
  if (newEval) new Collapse(newEval, { toggle: false }).show();

  // --- Fill fields ---
  (document.getElementById("firstname") as HTMLInputElement).value = data.firstname;
  (document.getElementById("lastname") as HTMLInputElement).value = data.lastname;
  (document.getElementById("mail") as HTMLInputElement).value = data.mail;
  (document.getElementById("date") as HTMLInputElement).value = data.date;

  // --- Profile pic initials ---
  const profilePic = document.getElementById("profile-pic");
  profilePic!.innerHTML = `
    <div class="portrait p-2 mx-auto">
        <img class="card-img-top rounded-circle anonymous" src="${anonymousImg}" alt="Card image cap"></img>
        <span class="initials">${data['firstname'][0].toUpperCase()}${data['lastname'][0].toUpperCase()}</span>
    </div>`;

  // --- Enable the submit button ---
  const registerBtn = document.getElementById("register") as HTMLButtonElement | null;
  if (registerBtn) registerBtn.disabled = false;

  // --- Get user subscriptions ---
  const access_token = getCookie("access_token");
  const subData = await io.getSubs(access_token);
  // store user sub as global variable
  (window as any).subData = subData

  // --- Fill select options ---
  const currentSub = document.getElementById("current-sub") as HTMLSelectElement | null;

  if (currentSub) {
    if (subData.length > 0) {
      currentSub.innerHTML = subData
        .map((sub) =>
          `<option sub-id="${sub.id}">${sub.name} (${sub.param}-${sub.model}-lev${sub.level})</option>`
        ).join("");
    } else {
      currentSub.innerHTML = `<option>No current alert subscribed to</option>`;
    }

    // Select last option and trigger change event
    if (currentSub.options.length > 0) {
      const last = currentSub.options[currentSub.options.length - 1];
      last.selected = true;
      currentSub.dispatchEvent(new Event("change"));
    }
  }
  showCurrentSub()
}


export async function uploadModelData() {
  const uploadStatusEl = document.getElementById('upload-status')
  if (!uploadStatusEl) return;

  uploadStatusEl.innerHTML =
    '<span class="spinner-border spinner-border-sm" role="status"></span> Uploading...';

  await delay(1000);
  const success = Math.random() > 0.2;
  await updateBadgeStatus('upload-status', success);
  checkBadgesStatus();
}

export function showCurrentSub() {
  const subData = (window as any).subData as SubData[]
  //get form to know what is selected
  const selectedSub = (document.forms as any)['profile-form']['current-sub']?.selectedIndex;
  //id of sub
  if (selectedSub) fillInCurrentSubForms(subData[selectedSub]);
}


export function fillInCurrentSubForms(sub: SubData) {
  const keys: (keyof SubData)[] = ['name', 'param', 'model', 'level'];

  for (const key of keys) {
    const meta = (window as any).subscription[key];

    if (!meta) continue;

    if (meta.class === 'form-control') {
      const input = document.querySelector<HTMLInputElement>(`#current-sub-${key} > input`);
      if (input) input.value = String(sub[key]);
    } else if (meta.class === 'form-group') {
      const select = document.querySelector<HTMLSelectElement>(`select#current-sub-${key}`);
      if (select) {
        // select the option matching the subscription value
        for (const option of Array.from(select.options)) {
          option.selected = option.value === String(sub[key]);
        }
      }
    }

    // disable update button initially
    const updateButton = document.getElementById('update-but') as HTMLButtonElement;
    if (updateButton) updateButton.disabled = true;
  }
}

function showCollapse(id: string) {
  const el = document.getElementById(id);
  if (!el) return;

  // Ensure DOM visual state is consistent
  el.classList.add('show');

  // Get existing instance without auto-toggle
  let collapse = Collapse.getInstance(el);
  if (!collapse) {
    collapse = new Collapse(el, { toggle: false });
  }

  collapse.show();
}

function hideCollapse(id: string) {
  const el = document.getElementById(id);
  if (!el) return;

  // Get existing instance (DO NOT auto-initialize)
  let collapse = Collapse.getInstance(el);
  if (!collapse) {
    collapse = new Collapse(el, { toggle: false });
  }

  collapse.hide();
}

export function showSignUp() {
  showCollapse('sign-up');
  hideCollapse('sign-in');
  const mailStatus = document.getElementById('mail-status');
  if (mailStatus) mailStatus.innerHTML = '';
}

export function showSignIn() {
  showCollapse('sign-in');
  hideCollapse('sign-up');
  const passwordStatus = document.getElementById('password-status');
  if (passwordStatus) passwordStatus.innerHTML = '';
}

export function showResetPassword() {
  showCollapse('resetpassword');
  hideCollapse('sign-in');
  const resetStatus = document.getElementById('resetpassword-status');
  if (resetStatus) resetStatus.innerHTML = '';
}

export function showPrivacyPolicy() {
  showCollapse('privacy-policy');
  hideCollapse('sign-in');
}

export function hidePrivacyPolicy() {
  hideCollapse('privacy-policy');
  showCollapse('sign-in');
}

export function enableSignUp(captchaResponse: string) {
  const btn = document.getElementById("sign-up-but") as HTMLButtonElement;
  if (!btn) return
  btn.disabled = false;
  setCookie("recaptcha", captchaResponse, 1);
}

export function enableResetPassword(captchaResponse: string) {
  const form = (document.forms as any)["resetpassword-form"];
  const emailInput = form?.[0] as HTMLInputElement;
  const button = document.getElementById("resetpassword-but") as HTMLButtonElement;
  if (!emailInput || !button) return
  button.disabled = !emailInput.value.includes("@");
  setCookie("recaptcha", captchaResponse, 1);
}

export async function signUp(event?: Event) {
  event?.preventDefault(); // Prevent default form submission behavior
  const signUpData = getForm('sign-up-form');
  if (!signUpData) return;

  const mailStatus = document.getElementById('mail-status') as HTMLElement;
  const mailAction = document.getElementById('mail-action') as HTMLElement;
  if (!mailStatus || !mailAction) return

  try {
    const userData = await io.addUser(
      signUpData['firstname'],
      signUpData['lastname'],
      signUpData['mail'],
      signUpData['password'],
      getCookie('recaptcha')
    );

    setCookie('access_token', userData.access_token, 1);
    mailStatus.textContent = 'The profile has been successfully created';
    mailStatus.className = 'text-success';

    setTimeout(() => {
      initUser();
      hideCollapse('sign-up');
    }, 1000);

  } catch {
    mailStatus.textContent = 'This email address is already in use';
    mailStatus.className = 'text-danger';

    mailAction.innerHTML = `
            <br><a id="show-sign-in-but" href="#">Sign in</a>
            <br><a id="show-reset-password-but" href="#">Forgot your password</a>
        `;

    document.getElementById('show-sign-in-but')?.addEventListener('click', () => {
      showSignIn()
    })
    document.getElementById('show-reset-password-but')?.addEventListener('click', () => {
      showResetPassword()
    })
  }
}

function delay(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export async function makeConfigFile() {
  const makeCfgStatusEl = document.getElementById('make-cfg-status');
  if (!makeCfgStatusEl) return;

  makeCfgStatusEl.innerHTML =
    '<span class="spinner-border spinner-border-sm" role="status"></span> Make cfg...';

  await delay(1000);
  const success = Math.random() > 0.2;
  await updateBadgeStatus('make-cfg-status', success);
  checkBadgesStatus();
}

async function updateBadgeStatus(divId: string, success: boolean) {
  const uploadStatusEl = document.getElementById(divId)
  if (!uploadStatusEl) return;

  uploadStatusEl.innerHTML = success
    ? '<span class="badge badge-pill bg-success">Success</span>'
    : '<span class="badge badge-pill bg-danger">Fail</span>'
}

export async function submitEvaluation() {
  console.log("submit evaluation")

  const data = getForm('config-file-form');
  if (!data) return;

  const accessToken = getCookie('access_token');
  if (!accessToken) return;

  const coords = 'no coords, just test';
  const statusEl = document.getElementById("submit-status");
  if (!coords || !statusEl) return;

  function showStatus(statusEl: HTMLElement, message: string, bootstrapClass: string, durationMs: number) {
    // Reset classes
    statusEl.classList.remove("text-success", "text-danger");
    statusEl.classList.add(bootstrapClass);

    // Update message
    statusEl.textContent = message;

    // Show collapse
    showCollapse("submit-status");

    // Hide after delay
    setTimeout(() => {
      hideCollapse("submit-status");
    }, durationMs);
  }

  try {
    await io.addSub(accessToken, data["param"], data["model"], Number(data["level"]), data["experiment"], coords);
    showStatus(statusEl, "New subscription registered", "text-success", 3000);
    setTimeout(() => initUser(), 1000);
    //setTimeout(() => newEvent(), 3000);
  } catch (err) {
    console.error(err);
    showStatus(statusEl, "Subscription failed", "text-danger", 5000);
  }
}


export function logOut() {
  setCookie('access_token', 'null');
  hideCollapse("new-eval");
  hideCollapse("profile");
  showSignIn();
}

export async function resetPassword() {
  //get form to know what is selected
  const data = getForm('resetpassword-form');
  if (!data) return

  const statusElement = document.getElementById("resetpassword-status");
  if (!statusElement) return;

  try {
    const mail = data['mail']
    const recaptcha = getCookie('recaptcha')
    await io.emailPasswordChangeRequest(mail, recaptcha)

    statusElement.className = "text-success";
    statusElement.textContent = "An email has just been sent to you";
    statusElement.style.display = "block";

  } catch {
    statusElement.className = "text-danger";
    statusElement.textContent = "This email address is not registered";
    statusElement.style.display = "block";
  }

  // fade out nicely after 3s
  setTimeout(() => {
    statusElement.classList.add("fade-out");

    // remove from DOM after transition ends
    statusElement.addEventListener(
      "transitionend",
      () => {
        statusElement.classList.replace("fade-out", "hidden");
      },
      { once: true }
    );
  }, 3000);

}

/*async function getPyaeroptions() {
  (window as any).menu = await utils.getConfig('menu.json')
}*/

async function getForms() {
  const subForms = await utils.getConfig('sub-forms.json');
  (window as any).subscription = subForms;
  fillOutForms('config-file', subForms, 'make-cfg-but');
  fillOutForms('current-sub', subForms, 'update-but');
  checkBadgesStatus()
}

function fillOutForms(preKey: string, formsData: any, buttonId?: string) {
  const buttonElement = buttonId ? document.getElementById(buttonId) as HTMLButtonElement : null;
  for (let key in formsData) {
    const form = formsData[key];
    const formElement = document.getElementById(`${preKey}-${key}`)
    if (!formElement) continue
    let h = ''
    if (form.class == 'form-control') {
      const placeholder = form.placeholder ? `placeholder="${form.placeholder}"` : ''
      const required = form.required ? 'required' : ''
      h += `<label for="subForm">${form.title}</label>
            <input class="form-control" id="${preKey}-${key}" ${placeholder} ${required}>
            `;
    } else if (form.class == 'form-group') {
      h += `<div class="form-group">
            <label for="exampleFormControl${preKey}${key}">${form.title}</label>
            <select class="form-control" id="${preKey}-${key}">`;
      for (let option of form.options) {
        let disabled = option.disabled ? 'disabled' : ''
        h += `<option value="${option.value}" ${disabled}>${option.name}</option>`;
      }
      h += `</select>`;
      if (form.help) h += `<div id="help-${key}" class="form-text">${form.help}</div>`;
      h += `</div>`;
    }
    formElement.innerHTML = h;

    // activate button if all forms are filled
    if (!buttonElement) continue
    const inputs = formElement?.querySelectorAll('input, keyup, select, change');
    if (!inputs) return
    function updateButtonState() {
      const allFilled = Array.from(inputs).every(el => {
        if (el instanceof HTMLInputElement) {
          return el.type === 'checkbox' ? el.checked : el.value.trim() !== '';
        }
        return (el as any).value !== '';
      });

      if (buttonElement) buttonElement.disabled = !allFilled;
    }

    ['keyup', 'change', 'input'].forEach(event => {
      inputs.forEach(el => el.addEventListener(event, updateButtonState));
    });
  }

}

// Send sign-in form by pressing Enter key
document.getElementById('sign-in-password')?.addEventListener('keydown', (event) => {
  if (event.key === 'Enter') {
    event.preventDefault();
    document.getElementById('sign-in-but')?.click();
  }
});

/*verify reset field*/
/*document.getElementById('resetpassword-form').addEventListener('keyup', function (event) {
    //must include @
    if (document.forms['resetpassword-form'][0].value.includes('@')) {
        document.getElementById('resetpassword-but').disabled = false;
    } else {
        document.getElementById('resetpassword-but').disabled = true;
    }
});*/


function checkBadgesStatus() {
  const divIds = ['upload-status', 'make-cfg-status'];
  // count number of badges with success status
  let success = 0
  let total = 0
  divIds.forEach(divId => {
    const statusEl = document.getElementById(divId)
    if (!statusEl) return;
    if (statusEl.innerHTML.includes('bg-success')) success++
    total++
  });

  const submitButton = document.getElementById('submit-but') as HTMLButtonElement;
  if (!submitButton) return;
  // enable submit button if all badges are success
  submitButton.disabled = success < total

  const submitStatusEl = document.getElementById('submit-status')
  if (!submitStatusEl) return;

  submitStatusEl.innerHTML = success === total
    ? `<span class="text">${success}/${total}</span>`
    : `<span class="text">${success}/${total}</span>`
}